// Mobile-Safari workaround: 100vh includes the URL bar, so position:fixed elements
// that target the visible viewport need a CSS variable that tracks innerHeight.
// Only re-evaluates on resize above the 1024 breakpoint to avoid jitter when the
// mobile URL bar collapses/expands during scroll.
const appHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
};

window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) appHeight();
});

appHeight();
